// extracted by mini-css-extract-plugin
module.exports = {"container":"Fb","block":"Gb","subheading":"Hb","cta":"Ib","disabled":"Jb","noBotMargin":"Kb","light":"Lb"};